import { ValidatorFn } from '@angular/forms';
import { BoatExistsValidator } from '@shared/validators/boat/exists';

export class U2bBoatValidators {
    public static boatExists(message?: string): ValidatorFn {
        return new BoatExistsValidator(message).asValidatorFn();
    }
}
